import React from 'react';
import InputMask from 'react-input-mask';

interface DefaultMaskOptions {
  id: string,
  mask: string,
  value: string,
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void,

}

const InputMasked = ({
  mask, value, onChange, id,
}: DefaultMaskOptions) => (
  <InputMask
    maskChar={null}
    id={id}
    mask={mask}
    value={value}
    onChange={onChange}
  />
);

export default InputMasked;
